import { pigletRegistrationColors as c } from '../PigletRegistration/colors';

/**
 * Colours for the unsynced-device card, taken from the dashboard palette rather than picked fresh, and
 * mapped to the same meanings the readers widget already gives them: green for "nothing to do", amber for a
 * queue worth watching, red for one nobody has resolved.
 *
 * Deliberately the same three-step severity scale as `readerStatusColors`, because the two cards answer the
 * same shape of question about two kinds of device - a farm user should not have to learn that amber means
 * something different here.
 */
export const deviceSyncColors = {
  /** A queue that is still being worked through. */
  draining: c.neutral,

  /** Standing longer than a couple of hours. */
  delayed: c.target,

  /** Standing longer than a day. */
  stuck: c.belowExpected
} as const;
